export default {"src":"/_next/static/media/plums.56b6830a.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};